<template>
  <div class="page-landing">
    <div class="landing">
      <div class="title">Добро пожаловать<br />в личный кабинет<br />вашего здоровья</div>

      <div class="text">
        Здесь будут ваши назначения, графики приема препаратов, а в будущем результаты анализов,
        метрики и индикаторы прогресса. Все, чтобы поддерживать своё здоровье было просто и удобно.
      </div>

      <div class="sub">Команда Life Plus</div>
    </div>

    <div class="button" @click="skip">Продолжить</div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    methods: {
      skip() {
        this.$store.commit('SET_FIRST_LOGIN', false);
      }
    }
  }
</script>

<style lang="scss">
  @import "../assets/scss/variables.scss";

  .page-landing {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    background-image: url('../assets/img/splash.jpg');
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;

    .landing {
      position: absolute;
      top: 50%;
      left: 50%;
      height: 200px;
      width: 300px;
      margin: -150px 0 0 -150px;

      .title {
        text-align: center;
        font-size: 22px;
        margin: 0 0 30px;
        line-height: 22px;
      }

      .text {
        margin: 0 30px 30px;
        font-weight: bold;
        font-size: 12px;
        text-align: center;
        line-height: 16px;
      }

      .sub {
        font-weight: bold;
        font-size: 12px;
        text-align: right;
      }
    }

    .button {
      position: absolute;
      bottom: 40px;
      left: 50%;
      height: 32px;
      width: 150px;
      margin: 0 0 0 -75px;
      padding: 0 10px;
      font-size: 12px;
      font-weight: bold;
      text-align: center;
      text-transform: uppercase;
      line-height: 32px;
      background-color: $primary;
      border-radius: 20px;
    }
  }
</style>
